import { Search } from '@mui/icons-material';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  id?: string;
}
const Searchbar = ({ value, onChange, onEnter, id }: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }

        if (e.key === 'Enter' && onEnter) {
          onEnter();
        }
      }}
      placeholder="Find a company or security"
      value={value}
      onChange={handleChange}
      autoComplete="off"
      fullWidth={true}
      InputProps={{
        startAdornment: <Search />,
      }}
      inputProps={{
        id,
        style: {
          marginLeft: 16,
        },
      }}
    />
  );
};

export default Searchbar;
